import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { slot: "time-label" }
const _hoisted_2 = { slot: "time-label" }
const _hoisted_3 = { slot: "time-label" }
const _hoisted_4 = { slot: "time-label" }
const _hoisted_5 = {
  key: 0,
  class: "pt-1 fs-small",
  style: {"color":"var(--ion-color-danger)"}
}
const _hoisted_6 = {
  class: "ion-justify-content-end d-flex ion-align-items-end flex-d-c",
  style: {"gap":"0.5rem","padding-inline":"5px"}
}
const _hoisted_7 = {
  key: 0,
  class: "fw-b purple-purple-color fs-larger ion-text-right"
}

import { IonCol, IonDatetime, IonGrid, IonRow } from "@ionic/vue";
import { computed, onActivated, onDeactivated, reactive, ref } from "vue";
import { DateTime } from "luxon";

import SelectSimple from "@/components/selects/SelectSimple.vue";
import CheckboxSimple from "@/components/checkbox/CheckboxSimple.vue";
import InputSimple from "@/components/input/InputSimple.vue";
import TextareaBase from "@/components/input/TextareaBase.vue";
import ButtonBase from "@/components/button/ButtonBase.vue";

import { useListStore } from "@/stores/lists";
import { useSupplierStore } from "@/stores/suppliers";

import { sameDay } from "@/functions/luxon";

import { CartData, DeliveryDate } from "@/types/supplier";
import {
    DELIVERY_DATE_TYPE,
    ORDER_DATE,
    ORDER_DATE_PICKUP,
    PAYMENT_METHOD,
    PAYMENT_OPTIONS
} from "@/types/enum/supplierEnum";
import { DELIVERY_TYPE } from "@/types/enum/order";
import { DATE_FORMAT } from "@/types/enum/luxonEnum";
import { useI18n } from "vue-i18n";
import { sentryTrack } from "@/plugins/sentry";
import { useUserStore } from "@/stores/user";
import { useRouteParams } from "@/composables/useRouteParams";
import { convertNumberWithComma } from "@/functions/converter";
import { CURRENCY_EUR } from "@/assets/variables";
import Warning from "@/components/warning/Warning.vue";

import { isPlatform } from "@ionic/core";

type IonDateFormattingInfo = {
    textColor: string;
    backgroundColor?: string;
} | {
    textColor?: string;
    backgroundColor: string;
};

type IonHighlightDate = {
    date: string;
    textColor: string;
    backgroundColor: string;
}

const greyText = 'rgba(var(--ion-color-purple-rgb), 0.2)'
const palePink = 'rgba(var(--ion-color-coral-rgb), 0.2)'
const pink = 'var(--ion-color-coral)'

// TODO: Add Input validation for order message max length: 255

export default /*@__PURE__*/_defineComponent({
  __name: 'OrderPayment',
  props: {
    cartData: {}
  },
  emits: ["next"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v2c9db1bb": (ionDateWheelHighlight.value),
  "a6703f64": (ionDateBorder.value)
}))

const props = __props
const emit = __emit

// TODO Move to types folder
const { t } = useI18n()
const listStore = useListStore()
const supplierStore = useSupplierStore()
const highlightDeliveryDays = ref<IonHighlightDate[]>([])
const highlightPickupDays = ref<IonHighlightDate[]>([])
const today = ref(DateTime.now().toString())
const threeMonthsLater = ref(DateTime.now().plus({ months: 3 }).toString());
const voucher = ref<string>('')
const redeemVoucher = ref<boolean>(false)

const { locationId } = useRouteParams()

const paymentOptions = reactive<{ value: PAYMENT_METHOD, text: string }[]>([])
const pickupOptions = reactive<{ value: string, text: string }[]>([])
const deliveryOptions = reactive<{ value: string, text: string }[]>([])

const summarySum = computed(() => props.cartData.summary.reduce((accumulator, currentValue) => {
    return accumulator + ((currentValue.quantity ?? 0) * (currentValue.item.price ?? 0))
}, 0))

const amountProducts = computed<number>(() => {
    let amount = props.cartData.cartItems?.length ?? 0
    if (!props.cartData.lists) return amount
    for (const list of props.cartData.lists) {
        amount += list.cartItems.length
    }
    return amount
})

const isOutOfSchedule = computed<boolean>(() => {
    const supplierInfo = supplierStore.suppliers.data.find((i) => i.id === props.cartData.supplier.id);
    if (!supplierInfo) return false;
    const scheduleDeliveryDays = supplierInfo.deliveryDays;
    if (!scheduleDeliveryDays || !scheduleDeliveryDays?.length) return false;
    const deliveryDay = new Date(String(listStore.order.deliveryDate)).getDay();
    return !scheduleDeliveryDays.includes(deliveryDay);
})

const isHolidayDelivery = computed<boolean>(() => {
    const supplierDates = supplierStore.deliveryDays[props.cartData.supplier.id]

    if (!supplierDates) return false

    const deliveryDate = supplierDates.find(deliveryDate => sameDay(
        String(listStore.order.deliveryDate),
        DateTime.fromFormat(deliveryDate.date, DATE_FORMAT.INPUT)
    ))

    if (!deliveryDate) return false

    return deliveryDate.type === DELIVERY_DATE_TYPE.HOLIDAY
})

const isHolidayPickup = computed<boolean>(() => {
    const supplierDates = supplierStore.pickupDays[props.cartData.supplier.id]

    if (!supplierDates) return false

    const pickupDate = supplierDates.find(pickupDate => sameDay(
        String(listStore.order.pickupDate),
        DateTime.fromFormat(pickupDate.date, DATE_FORMAT.INPUT)
    ))

    if (!pickupDate) return false

    return pickupDate.type === DELIVERY_DATE_TYPE.HOLIDAY
})

const orderDateNotSpecified = (): boolean => {
    //not sure if i need to check this (props.cartData.supplier.deliveryTiming !== ORDER_DATE.NOTHING) too, maybe you can remove it
    const deliveryNotSpecified = listStore.order.selectedDeliveryType === DELIVERY_TYPE.DELIVERY && props.cartData.supplier.deliveryTiming !== ORDER_DATE.NOTHING && !listStore.order.deliveryDate
    const pickupNotSpecified = listStore.order.selectedDeliveryType === DELIVERY_TYPE.PICKUP && props.cartData.supplier.pickupTiming !== ORDER_DATE_PICKUP.UNAVAILABLE && !listStore.order.pickupDate

    return !!(deliveryNotSpecified || pickupNotSpecified);
}

const orderAmountList = (): number => {
    let amount = 0
    for (const noListItem of props.cartData.cartItems) {
        amount += noListItem.quantity
    }
    for (const list of props.cartData.lists) {
        for (const listItem of list.cartItems) {
            amount += listItem.quantity
        }
    }
    return amount
}

const isScheduled = (isoDate: string): boolean => {
    const supplierDates = supplierStore.deliveryDays[props.cartData.supplier.id]

    if (!supplierDates) return true //Fallback if no info is found

    const deliveryDate = supplierDates.find(deliveryDate => sameDay(isoDate, DateTime.fromFormat(deliveryDate.date, DATE_FORMAT.INPUT)))

    if (!deliveryDate) return true //Fallback if no info is found

    return deliveryDate.selectable
}

const isPickupScheduled = (isoDate: string): boolean => {
    const supplierDates = supplierStore.pickupDays[props.cartData.supplier.id]

    if (!supplierDates) return true // fallback if no info is found

    const pickupDate = supplierDates.find(deliveryDate => sameDay(isoDate, DateTime.fromFormat(deliveryDate.date, DATE_FORMAT.INPUT)))

    if (!pickupDate) return true // fallback if no info is found

    return pickupDate.selectable
}

const enablePickup = (): boolean => {
    return !!props.cartData.supplier.pickupLocations?.length
}

const enableDelivery = (): boolean => {
    // return props.cartData.supplier.pickupTiming === ORDER_DATE.NOTHING
    return true
}

const changeSettings = (newValue: DELIVERY_TYPE | PAYMENT_METHOD) => {
    const settings = props.cartData.supplier?.settings ?? {}

    if (newValue === DELIVERY_TYPE.PICKUP) {
        settings.distribution = {
            pickupLocation: props.cartData.supplier.settings?.distribution?.pickupLocation ?? '',
            method: newValue
        }
    } else if (newValue === DELIVERY_TYPE.DELIVERY) {
        settings.distribution = {
            method: newValue
        }
    } else if (Object.values(PAYMENT_METHOD).includes(newValue)) {
        settings.paymentMethod = newValue
    } else {
        settings.distribution = {
            pickupLocation: newValue,
            method: DELIVERY_TYPE.PICKUP,
        }
    }
}

const checkDeleteVoucher = (event: boolean): void => {
    if (event) return

    listStore.order.promoCode = undefined
}

const getTextColor = (date: DeliveryDate): string => {
    if (sameDay(DateTime.now(), date.date)) return pink
    if (date.selectable && (!date.available || date.type === DELIVERY_DATE_TYPE.WEEKEND)) return greyText
    return 'var(--ion-color-purple)'
}

const getBackgroundColor = (date: DeliveryDate): string => {
    if (date.type === DELIVERY_DATE_TYPE.HOLIDAY) return palePink
    return 'transparent'
}

const parseDateHighlights = async () => {
    const parsedDates: IonHighlightDate[] = []
    if (!supplierStore.deliveryDays[props?.cartData?.supplier?.id]) await supplierStore.getSupplierDeliveryDays(locationId.value, props.cartData.supplier.id)

    for (const deliveryDay of supplierStore.deliveryDays[props.cartData.supplier.id]) {
        parsedDates.push({
            date: deliveryDay.date,
            textColor: getTextColor(deliveryDay),
            backgroundColor: getBackgroundColor(deliveryDay)
        })
    }
    highlightDeliveryDays.value = parsedDates

    if (enablePickup()) {
        const parsedPickupDates: IonHighlightDate[] = []
        if (!supplierStore.pickupDays[props?.cartData?.supplier?.id]) await supplierStore.getSupplierPickupDays(locationId.value, props.cartData.supplier.id)

        for (const pickupDay of supplierStore.pickupDays[props.cartData.supplier.id]) {
            parsedPickupDates.push({
                date: pickupDay.date,
                textColor: getTextColor(pickupDay),
                backgroundColor: getBackgroundColor(pickupDay)
            })
        }
        highlightPickupDays.value = parsedPickupDates;
    }    
}

const trackOrder = () => {
    sentryTrack({
        message: 'User order',
        userId: useUserStore().sessionInfo.id,
        extra: {
            deliveryDate: listStore.order.deliveryDate
        }
    })
    emit('next')
}

onDeactivated(() => {
    today.value = DateTime.now().toFormat('yyyy-MM-dd').toString()
    voucher.value = ''
    redeemVoucher.value = false
    paymentOptions.splice(0)
    pickupOptions.splice(0)
    deliveryOptions.splice(0)
})

onActivated(() => {
    switch (props.cartData.supplier.paymentOptions) {
        case PAYMENT_OPTIONS.ON_ACCOUNT_OR_CASH:
            Object.assign(paymentOptions, [
                {
                    value: PAYMENT_METHOD.CASH,
                    text: t('label.cash')
                },
                {
                    value: PAYMENT_METHOD.ON_ACCOUNT,
                    text: t('label.onAccount')
                }
            ])
            break;
        case PAYMENT_OPTIONS.ON_ACCOUNT:
            Object.assign(paymentOptions, [{ value: PAYMENT_METHOD.ON_ACCOUNT, text: t('label.onAccount') }])
            break;
        case PAYMENT_OPTIONS.CASH:
            Object.assign(paymentOptions, [{ value: PAYMENT_METHOD.CASH, text: t('label.cash') }])
            break;
        default:
            listStore.order.paymentMethod = PAYMENT_METHOD.UNSPECIFIED
            break;
    }

    if (enableDelivery()) deliveryOptions.push({
        text: t('messages.order.delivery'),
        value: DELIVERY_TYPE.DELIVERY
    })
    if (enablePickup()) deliveryOptions.push({
        text: t('messages.order.pickup'),
        value: DELIVERY_TYPE.PICKUP
    })

    parseDateHighlights()

    const supplierSettings = useSupplierStore().supplierById(props.cartData.supplier.id)?.settings

    if (supplierSettings) {
        listStore.order.paymentMethod = supplierSettings.paymentMethod ?? PAYMENT_METHOD.UNSPECIFIED
        if (supplierSettings.distribution) {
            if (supplierSettings.distribution.pickupLocation) {
                listStore.order.pickupLocation = supplierSettings.distribution.pickupLocation
            }
        }
    }

    if (!listStore.order.selectedDeliveryType && deliveryOptions.length > 0)
        listStore.order.selectedDeliveryType = deliveryOptions[0].value

    if (!props.cartData.supplier.pickupLocations) return
    if (props.cartData.supplier.pickupLocations.length === 1) listStore.order.pickupLocation = props.cartData.supplier.pickupLocations[0]
    for (const location of props.cartData.supplier.pickupLocations) {
        pickupOptions.push({ text: location, value: location })
    }
})

const ionDateWheelHighlight = computed(() => isPlatform('android') ? '#ffdbea' : '')
const ionDateBorder = computed(() => isPlatform('android') ? '1px solid var(--ion-color-grey3-tint)' : '')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonGrid), { class: "p-0 max-height purple-purple-color" }, {
    default: _withCtx(() => [
      (deliveryOptions.length && __props.cartData.supplier.deliveryTiming !== _unref(ORDER_DATE).NOTHING)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_unref(IonRow), { class: "grey4-grey4-background" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), { class: "p-3 fw-b" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('messages.order.deliveryType')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), { class: "p-3" }, {
                  default: _withCtx(() => [
                    _createVNode(SelectSimple, {
                      class: "unset-max-width",
                      placeholder: _ctx.$t('messages.order.deliveryType'),
                      modelValue: _unref(listStore).order.selectedDeliveryType,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(listStore).order.selectedDeliveryType) = $event)),
                      onChange: changeSettings,
                      options: deliveryOptions
                    }, null, 8, ["placeholder", "modelValue", "options"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true),
      (__props.cartData
        && (__props.cartData.supplier.deliveryTiming === _unref(ORDER_DATE).DATE || __props.cartData.supplier.deliveryTiming === _unref(ORDER_DATE).DATETIME)
        && _unref(listStore).order.selectedDeliveryType === _unref(DELIVERY_TYPE).DELIVERY)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_unref(IonRow), { class: "grey4-grey4-background" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), { class: "p-3 fw-b" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('messages.order.deliveryTime')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (__props.cartData.supplier.deliveryTiming === _unref(ORDER_DATE).DATE)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_unref(IonRow), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCol), { class: "p-3 fw-b" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('label.date')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonRow), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCol), { class: "px-3 center" }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_unref(IonDatetime), {
                            class: "grey4-grey4-background custom-datetime",
                            presentation: "date",
                            min: today.value ?? '',
                            max: threeMonthsLater.value,
                            modelValue: _unref(listStore).order.deliveryDate,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(listStore).order.deliveryDate) = $event)),
                            locale: _ctx.$i18n.locale,
                            "first-day-of-week": 1,
                            "highlighted-dates": highlightDeliveryDays.value,
                            "is-date-enabled": isScheduled,
                            key: highlightDeliveryDays.value.length
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('label.time')), 1)
                            ]),
                            _: 1
                          }, 8, ["min", "max", "modelValue", "locale", "highlighted-dates"]))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 64))
              : (__props.cartData.supplier.deliveryTiming === _unref(ORDER_DATE).DATETIME)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_unref(IonRow), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCol), { class: "p-3 fw-b" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('label.date')) + " " + _toDisplayString(_ctx.$t('label.and')) + " " + _toDisplayString(_ctx.$t('label.time')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonRow), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCol), { class: "px-3 center" }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_unref(IonDatetime), {
                              class: "grey4-grey4-background custom-datetime order-filter-month",
                              presentation: "date-time",
                              min: today.value ?? '',
                              max: threeMonthsLater.value,
                              modelValue: _unref(listStore).order.deliveryDate,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(listStore).order.deliveryDate) = $event)),
                              "highlighted-dates": highlightDeliveryDays.value,
                              "is-date-enabled": isScheduled,
                              locale: _ctx.$i18n.locale,
                              "first-day-of-week": 1,
                              key: highlightDeliveryDays.value.length
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('label.time')), 1)
                              ]),
                              _: 1
                            }, 8, ["min", "max", "modelValue", "highlighted-dates", "locale"]))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true),
            (_unref(listStore).order.deliveryDate && isOutOfSchedule.value && !isHolidayDelivery.value)
              ? (_openBlock(), _createBlock(_unref(IonRow), { key: 2 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), { class: "px-3" }, {
                      default: _withCtx(() => [
                        _createVNode(Warning, {
                          title: _ctx.$t('messages.deliveryDayWarningTitle'),
                          body: _ctx.$t('messages.deliveryDayWarning'),
                          orange: ""
                        }, null, 8, ["title", "body"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (isHolidayDelivery.value)
              ? (_openBlock(), _createBlock(_unref(IonRow), { key: 3 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), { class: "px-3" }, {
                      default: _withCtx(() => [
                        _createVNode(Warning, {
                          title: _ctx.$t('messages.holidayDeliveryTitle'),
                          body: _ctx.$t('messages.holidayDelivery'),
                          red: ""
                        }, null, 8, ["title", "body"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 64))
        : (__props.cartData && _unref(listStore).order.selectedDeliveryType === _unref(DELIVERY_TYPE).PICKUP)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(_unref(IonRow), { class: "grey4-grey4-background" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), { class: "p-3 fw-b" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('messages.order.pickupTime')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (__props.cartData.supplier.pickupLocations?.length)
                ? (_openBlock(), _createBlock(_unref(IonRow), { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCol), { class: "px-3 pt-3 pb-1" }, {
                        default: _withCtx(() => [
                          _createVNode(SelectSimple, {
                            class: "unset-max-width",
                            placeholder: _ctx.$t('placeholder.pickupMethod'),
                            modelValue: _unref(listStore).order.pickupLocation,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(listStore).order.pickupLocation) = $event)),
                            onChange: changeSettings,
                            options: pickupOptions,
                            disabled: props.cartData.supplier.pickupLocations?.length === 1
                          }, null, 8, ["placeholder", "modelValue", "options", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (__props.cartData.supplier.pickupTiming === _unref(ORDER_DATE).DATE)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_unref(IonRow), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCol), { class: "p-3 fw-b" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('label.date')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonRow), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCol), { class: "px-3 center" }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_unref(IonDatetime), {
                              class: "grey4-grey4-background custom-datetime",
                              presentation: "date",
                              min: today.value ?? '',
                              max: threeMonthsLater.value,
                              modelValue: _unref(listStore).order.pickupDate,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(listStore).order.pickupDate) = $event)),
                              locale: _ctx.$i18n.locale,
                              "first-day-of-week": 1,
                              "highlighted-dates": highlightPickupDays.value,
                              "is-date-enabled": isPickupScheduled,
                              key: highlightPickupDays.value.length
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('label.time')), 1)
                              ]),
                              _: 1
                            }, 8, ["min", "max", "modelValue", "locale", "highlighted-dates"]))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
                : (__props.cartData.supplier.pickupTiming === _unref(ORDER_DATE).DATETIME)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createVNode(_unref(IonRow), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCol), { class: "p-3 fw-b" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('label.date')) + " " + _toDisplayString(_ctx.$t('label.and')) + " " + _toDisplayString(_ctx.$t('label.time')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonRow), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCol), { class: "px-3 center" }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_unref(IonDatetime), {
                                class: "grey4-grey4-background custom-datetime order-filter-month",
                                presentation: "date-time",
                                min: today.value ?? '',
                                max: threeMonthsLater.value,
                                modelValue: _unref(listStore).order.pickupDate,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(listStore).order.pickupDate) = $event)),
                                locale: _ctx.$i18n.locale,
                                "first-day-of-week": 1,
                                "highlighted-dates": highlightPickupDays.value,
                                "is-date-enabled": isPickupScheduled,
                                key: highlightPickupDays.value.length
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('label.time')), 1)
                                ]),
                                _: 1
                              }, 8, ["min", "max", "modelValue", "locale", "highlighted-dates"]))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true),
              (isHolidayPickup.value)
                ? (_openBlock(), _createBlock(_unref(IonRow), { key: 3 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCol), { class: "px-3" }, {
                        default: _withCtx(() => [
                          _createVNode(Warning, {
                            title: _ctx.$t('messages.holidayPickupTitle'),
                            body: _ctx.$t('messages.holidayPickup'),
                            red: ""
                          }, null, 8, ["title", "body"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
      (paymentOptions.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createVNode(_unref(IonRow), { class: "grey4-grey4-background" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), { class: "p-3 fw-b" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('messages.order.choosePayment')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), { class: "px-3 pt-3 pb-1" }, {
                  default: _withCtx(() => [
                    _createVNode(SelectSimple, {
                      class: "unset-max-width",
                      placeholder: _ctx.$t('placeholder.paymentMethod'),
                      modelValue: _unref(listStore).order.paymentMethod,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(listStore).order.paymentMethod) = $event)),
                      onChange: changeSettings,
                      options: paymentOptions
                    }, null, 8, ["placeholder", "modelValue", "options"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true),
      (__props.cartData.supplier.orderHint)
        ? (_openBlock(), _createBlock(_unref(IonRow), { key: 4 }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), { class: "p-3 fs-larger" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('label.orderHint')) + ": \"" + _toDisplayString(__props.cartData.supplier.orderHint) + "\" ", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (__props.cartData.supplier.hasCoupon)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
            _createVNode(_unref(IonRow), { class: "grey4-grey4-background" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), { class: "p-3 fw-b" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('messages.order.voucher')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonRow), { class: "mt-2" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), { class: "px-3" }, {
                  default: _withCtx(() => [
                    _createVNode(CheckboxSimple, {
                      modelValue: redeemVoucher.value,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((redeemVoucher).value = $event)),
                      onChange: checkDeleteVoucher
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('messages.order.redeemVoucher')), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _withDirectives(_createVNode(_unref(IonRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), { class: "px-3" }, {
                  default: _withCtx(() => [
                    _createVNode(InputSimple, {
                      modelValue: _unref(listStore).order.promoCode,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(listStore).order.promoCode) = $event)),
                      placeholder: _ctx.$t('messages.order.voucherCode')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512), [
              [_vShow, redeemVoucher.value]
            ])
          ], 64))
        : _createCommentVNode("", true),
      (__props.cartData.supplier.orderQuestion)
        ? (_openBlock(), _createBlock(_unref(IonRow), {
            key: 6,
            class: "my-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), { class: "px-3" }, {
                default: _withCtx(() => [
                  _createVNode(CheckboxSimple, {
                    modelValue: _unref(listStore).order.orderCheckbox,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(listStore).order.orderCheckbox) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.cartData.supplier.orderQuestion), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (__props.cartData.supplier.allowsOrderMessage)
        ? (_openBlock(), _createBlock(_unref(IonRow), {
            key: 7,
            class: "pb-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), { class: "px-3" }, {
                default: _withCtx(() => [
                  _createVNode(TextareaBase, {
                    class: _normalizeClass(["grey4-grey4-background purple-purple-color p-1", {'max-length': Number(_unref(listStore).order.orderMessage?.length) >= 255}]),
                    style: {"border-radius":"8px"},
                    lines: "none",
                    modelValue: _unref(listStore).order.orderMessage,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(listStore).order.orderMessage) = $event)),
                    maxlength: 255,
                    placeholder: _ctx.$t('placeholder.sendMessageDeliverer', { deliverer: __props.cartData.supplier.name }),
                    debounce: 250
                  }, null, 8, ["class", "modelValue", "placeholder"]),
                  (Number(_unref(listStore).order.orderMessage?.length) >=255)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('error.returnType.OrderMessageTooLong')), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonRow), {
        class: "grey4-grey4-background py-2 fs-smaller grey1-grey1-color",
        style: {"padding-bottom":"34px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCol), {
            size: "auto",
            class: "d-flex flex-d-c ion-justify-content-end"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('messages.cart.amountItems', { amount: orderAmountList() })), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), { class: "py-0 center-y" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('messages.cart.amount', { amount: amountProducts.value })), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCol), null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                (__props.cartData.supplier.showCartTotal && summarySum.value > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(convertNumberWithComma)(summarySum.value.toFixed(3))) + " " + _toDisplayString(_unref(CURRENCY_EUR)) + " " + _toDisplayString(_ctx.$t('object.total')), 1))
                  : _createCommentVNode("", true),
                _createVNode(ButtonBase, {
                  class: "max-height m-0 wrap-button",
                  style: {"min-width":"120px"},
                  onClick: trackOrder,
                  disabled: orderDateNotSpecified()
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('button.finishOrder')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})